import React from 'react';

interface DirectionCellProps {
  direction: string;
}

const DirectionCell: React.FC<DirectionCellProps> = ({ direction }) => {
  const getDirectionColor = (direction: string) => {
    if (direction.includes('LONG') || direction.includes('BULLISH')) {
      return 'bg-green-100 text-green-800';
    } else if (direction.includes('SHORT') || direction.includes('BEARISH')) {
      return 'bg-red-100 text-red-800';
    } else {
      return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getDirectionColor(direction)}`}>
      {direction}
    </span>
  );
};

export default DirectionCell; 